var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckTranfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.564,
    height: 22.555,
    viewBox: "0 0 36.564 22.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 0.002,
    width: 36.564,
    height: 22.555,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.027)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 -1.029)",
    clipPath: "url(#a)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.535 -15.607)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -118.341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.891,0a2.019,2.019,0,0,1,2.018,2.018V15.473a2.019,2.019,0,0,1-2.018,2.018h-.673a4.036,4.036,0,1,1-8.073,0H10.764a4.036,4.036,0,1,1-8.073,0H1.345a1.346,1.346,0,0,1,0-2.691V9.978a2.692,2.692,0,0,1,.786-1.9l3.25-3.25a2.692,2.692,0,0,1,1.9-.786H9.418V2.018A2.019,2.019,0,0,1,11.436,0ZM9.418,6.728H7.286l-3.25,3.25v.786H9.418ZM22.2,17.492a2.018,2.018,0,1,0-2.018,2.018A2.018,2.018,0,0,0,22.2,17.492ZM6.727,15.473a2.018,2.018,0,1,0,2.018,2.018A2.018,2.018,0,0,0,6.727,15.473Z",
    transform: "translate(17.535 134.977)",
    fill: "rgba(139,139,139,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.013,0A2.016,2.016,0,0,0,0,2.018V15.473a2.016,2.016,0,0,0,2.013,2.018h.671a4.025,4.025,0,1,0,8.051,0H16.1a4.025,4.025,0,1,0,8.051,0h1.342a1.346,1.346,0,0,0,0-2.691V9.978a2.7,2.7,0,0,0-.784-1.9l-3.241-3.25a2.681,2.681,0,0,0-1.9-.786H17.443V2.018A2.016,2.016,0,0,0,15.431,0ZM17.443,6.728h2.126l3.241,3.25v.786H17.443ZM4.7,17.492A2.013,2.013,0,1,1,6.709,19.51,2.015,2.015,0,0,1,4.7,17.492Zm15.431-2.018a2.018,2.018,0,1,1-2.013,2.018A2.015,2.015,0,0,1,20.127,15.473Z",
    transform: "translate(49.598 134.977)",
    fill: "rgba(139,139,139,0.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.989 134.979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.363,13.913H.625A.626.626,0,0,0,0,14.538v2.919a.626.626,0,0,0,.625.626H16.363v2.4a1.251,1.251,0,0,0,2.135.885l4.486-4.486a1.251,1.251,0,0,0,0-1.769L18.5,10.627a1.251,1.251,0,0,0-2.135.885Z",
    transform: "translate(0 -10.258)",
    fill: "#81e9ae",
    stroke: "#fff",
    strokeWidth: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTranfer);
export default __webpack_public_path__ + "static/media/truck-tranfer.61b8df0bb07cc6d3367feeecde5b12a5.svg";
export { ForwardRef as ReactComponent };